import useReactHookForm from "hooks/useReactHookForm";
import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, vendorAccountInitialValues, vendorAccountProperties, vendorAccountValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";


export function VendorAccountFilter({
  setSearchPayload,
  setPage,
  clearValuesTrigger,
}) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    vendorAccountInitialValues,
    vendorAccountValidationSchema,
    "",
  );

  const handleSearch = () => {
    const payload: any = {};

    const searchId = watch("searchId");
    if (searchId) payload.searchId = parseInt(searchId);

    const vendorAccountId = watch("vendorAccountId");
    if (vendorAccountId) payload.vendorAccountId = parseInt(vendorAccountId);

    const associatedDomainName = watch("associatedDomainName");
    if (associatedDomainName) payload.associatedDomainName = associatedDomainName;

    const externalUserId = watch("externalUserId");
    if (externalUserId) payload.externalUserId = externalUserId;

    const isActive = watch("isActive");
    if (isActive === "true") payload.isActive = true;
    else if (isActive === "false") payload.isActive = false;

    const isUsed = watch("isUsed");
    if (isUsed === "true") payload.isUsed = true;
    else if (isUsed === "false") payload.isUsed = false;

    const createdAt = watch("created_at");
    if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
    if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if (updatedAt?.[0]) payload.updatedFrom = formatDateUtc(updatedAt[0]);
    if (updatedAt?.[1]) payload.updatedTill = formatDateUtc(updatedAt[1], true);

    setSearchPayload(payload);
    setPage(1);
  }


  const clearFilter = () => {
    setValue("searchId", "");
    setValue("vendorAccountId", "");
    setValue("associatedDomainName", "");
    setValue("externalUserId", "");
    setValue("isActive", "");
    setValue("isUsed", "");
    setValue("created_at", [null, null]);
    setValue("updated_at", [null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(() => {
    clearFilter()
  }, [clearValuesTrigger])

  return (
    //
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={vendorAccountProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "75px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["searchId", "vendorAccountId", "associatedDomainName", "externalUserId", "isActive", "isUsed", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "75px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["searchId", "vendorAccountId", "associatedDomainName", "externalUserId", "isActive", "isUsed", "created_at", "updated_at"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
